import React from "react"
import { useTranslation } from "react-i18next"

import { DEBT_NON_PAYABLE_BALANCE } from "config"
import Notice from "components/ui/Notice"

type Props = {
  balance: number
}

const HelpComponent = ({ balance }: Props) => {
  const { t } = useTranslation()

  const isVisible = balance >= DEBT_NON_PAYABLE_BALANCE

  return (
    <>
      {isVisible && (
        <Notice>{t("features.payment_schedule.notice.new")}</Notice>
      )}
    </>
  )
}

export default HelpComponent
